import { formatINR } from '../../../shared/utils/currency'

/** ₹1,23,456 — Indian digit grouping, no decimals. Every sales and accounts widget uses this. */
export const rupees = (amount: number) => formatINR(amount)

export const shortDate = (iso: string | null | undefined) => (iso ? new Date(iso).toLocaleDateString() : '—')

/** Tint a hex colour for a badge; falls back to muted styling when the colour is missing or not #rrggbb. */
export function badgeStyle(hex: string | null | undefined): React.CSSProperties | undefined {
  if (!hex || !/^#[0-9a-fA-F]{6}$/.test(hex)) return undefined
  return { color: hex, borderColor: `${hex}4d`, backgroundColor: `${hex}1a` }
}

/** 09:30 AM from an ISO timestamp, in the viewer's locale. */
export const shortTime = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' }) : '—'

const trimmed = (n: number) => String(parseFloat(n.toFixed(2)))

/** Short Indian money for tight spaces (chart axes, headline tiles): ₹1.25Cr, ₹3.5L, ₹45,000. */
export function rupeesCompact(amount: number): string {
  const abs = Math.abs(amount)
  const sign = amount < 0 ? '-' : ''
  if (abs >= 1e7) return `${sign}₹${trimmed(abs / 1e7)}Cr`
  if (abs >= 1e5) return `${sign}₹${trimmed(abs / 1e5)}L`
  return rupees(amount)
}
